module.exports = __webpack_public_path__ + "fonts/VWTextWeb-Bold.1a555dd0.woff";